import React, { useState, useContext } from "react";
import privateAxios from "../../utils/axiosPrivate";
import { showToast } from "../../utils/utils";
import { FaRegTrashAlt } from "react-icons/fa";
import MultiStepFormContext from "./../MultiStepForm/MultiStepFormContext";
import "./allaccountsteps.scss";
import {
  accSetting,
  buttonName,
  commonErrMsg,
  customersDtls,
  login,
  onboardingStepData,
  optimizationTexts,
  ownerTab,
  pagination,
  profiletexts,
  UserManagment
} from "../../locales/en";
import { getUserOnboardUrl } from "../../utils/constants/apiEndPoints";
import {
  EMAIL_REGEX_STRICT,
  NAME_REGEX,
  showToastType
} from "../../utils/constants/appConstants";

const getNameErrorMessage = (field, value) => {
  const fieldLabel =
    field === "firstName" ? optimizationTexts.first : optimizationTexts.last;

  if (value.trim() === "") {
    return `${fieldLabel} ${optimizationTexts.nameRequired}`;
  }
  if (value.length < 2) {
    return optimizationTexts.mustBeAtLeast;
  }
  return optimizationTexts.mustNotContain;
};

function OtherOwners() {
  const [errors, setErrors] = useState([]);
  const [buttonText, setButtonText] = useState(buttonName?.addOwner);
  const {
    otherOwners,
    setOtherOwners,
    next,
    prev,
    isConnectedSoftware,
    annatureStatusData
  } = useContext(MultiStepFormContext);
  const handleSubmit = async () => {
    let isValid = true;
    const newErrors = otherOwners?.map((owner) => ({
      firstName: owner.firstName
        ? ""
        : profiletexts?.errorMessage.firstNameRequired,
      lastName: owner.lastName
        ? ""
        : profiletexts?.errorMessage.lastNameRequired,
      email: owner.email ? "" : profiletexts?.errorMessage.emailRequired
    }));

    // Check if there are any validation errors
    if (
      newErrors.some((error) => Object.values(error).some((msg) => msg !== ""))
    ) {
      isValid = false;
    }

    setErrors(newErrors);

    if (isValid) {
      const hasNewOwners = otherOwners.some((owner) => owner.isNew === true);
      if (hasNewOwners) {
        const success = await createOtherOwnerPost();
        if (success) {
          next();
        }
      } else {
        next();
      }
    }
  };

  const handleAddOwner = () => {
    if (otherOwners.length < 3) {
      setOtherOwners([
        ...otherOwners,
        { firstName: "", lastName: "", email: "", isNew: true }
      ]);
      setErrors([...errors, { firstName: "", lastName: "", email: "" }]);
      setButtonText(optimizationTexts?.addAnotherBtn);
    }
  };

  const handleDeleteOwner = (index) => {
    const updatedOwners = otherOwners.filter((_, i) => i !== index);

    const reorderedOwners = updatedOwners.map((owner, i) => ({
      ...owner,
      ...(owner.id && { id: owner.id }),
      position: i + 1
    }));

    setOtherOwners(reorderedOwners);
    setErrors(errors.filter((_, i) => i !== index));

    if (reorderedOwners.length === 0) {
      setButtonText("Add Owner");
    }
  };

  const nameRegex = NAME_REGEX;
  const emailRegex = EMAIL_REGEX_STRICT;

  const handleInputChange = (index, field, value) => {
    const updatedOwners = [...otherOwners];
    updatedOwners[index][field] = value;

    const updatedErrors = [...errors];
    if (!updatedErrors[index]) {
      updatedErrors[index] = { firstName: "", lastName: "", email: "" };
    }

    if (field === "firstName" || field === "lastName") {
      if (!nameRegex.test(value)) {
        updatedErrors[index][field] = getNameErrorMessage(field, value);
      } else {
        updatedErrors[index][field] = "";
      }
    } else if (field === "email") {
      if (!emailRegex.test(value)) {
        updatedErrors[index].email =
          value.trim() === ""
            ? login?.errorMSG.emailRequired
            : login?.errorMSG.enterEmail;
      } else {
        updatedErrors[index].email = "";
      }
    }

    setOtherOwners(updatedOwners);
    setErrors(updatedErrors);
  };

  const createOtherOwnerPost = async () => {
    const dataToSubmit = otherOwners.filter((owner) => owner.isNew === true);
    try {
      const response = await privateAxios.post(getUserOnboardUrl, dataToSubmit);
      if (response.status >= 200 && response.status < 300) {
        setOtherOwners((prevOwners) =>
          prevOwners.map((owner) =>
            owner.isNew ? { ...owner, isNew: false } : owner
          )
        );
      }
      return true;
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.join(", ") ||
        error.response?.data?.message ||
        commonErrMsg?.item4;
      showToast(errorMessage, showToastType?.error);
      return false;
    }
  };

  const unconnectedStepTitle = annatureStatusData?.status
    ? onboardingStepData?.annatureConnected?.step5
    : onboardingStepData?.withoutConnected?.step4;
  const stepTitle = isConnectedSoftware
    ? customersDtls.tabs.title7
    : unconnectedStepTitle;

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="step-wrap">
            <div className="step-title">
              <h3>{stepTitle}</h3>
            </div>
            <div className="step-content">
              <div className="aplyid-section">
                <p>{ownerTab.stepContent.idRequirement}</p>
                <p>{ownerTab.stepContent.addOwnerInstructions}</p>

                <div className="addowners-wrap mt-4">
                  {otherOwners.length > 0 && (
                    <>
                      {otherOwners.slice(0, 3).map((owner, index) => (
                        <div
                          key={owner.id || index}
                          className="addowners-form mt-3"
                        >
                          <div className="row mb-3">
                            <div className="col-6 d-flex align-items-center">
                              <div className="owner-title">
                                <h4>
                                  {index + 1}. {customersDtls.tabs.title4}
                                </h4>
                              </div>
                            </div>
                            <div className="col-6">
                              {owner.isNew && (
                                <div className="delete-owner">
                                  <button
                                    type="button"
                                    className="delete"
                                    onClick={() => handleDeleteOwner(index)}
                                    title={ownerTab.deleteOwner}
                                  >
                                    <FaRegTrashAlt />
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-6">
                              <label htmlFor="" className="py-2">
                                {
                                  UserManagment.ownerTab.identificationSection
                                    .firstName
                                }
                                <sup>*</sup>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <div className="input-wrap">
                                <input
                                  name="firstName"
                                  type="text"
                                  value={owner?.firstName}
                                  onChange={(e) => {
                                    handleInputChange(
                                      index,
                                      "firstName",
                                      e.target.value
                                    );
                                  }}
                                  disabled={
                                    !owner.isNew &&
                                    Boolean(
                                      owner?.firstName &&
                                        owner?.firstName.trim() !== ""
                                    )
                                  }
                                />
                                {errors[index] && (
                                  <div className="error-text mt-1">
                                    {errors[index].firstName && (
                                      <p>{errors[index].firstName}</p>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-6">
                              <label htmlFor="" className="py-2">
                                {
                                  UserManagment.ownerTab.identificationSection
                                    .lastName
                                }
                                <sup>*</sup>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <div className="input-wrap">
                                <input
                                  name="lastName"
                                  type="text"
                                  value={owner?.lastName}
                                  onChange={(e) => {
                                    handleInputChange(
                                      index,
                                      "lastName",
                                      e.target.value
                                    );
                                  }}
                                  disabled={
                                    !owner.isNew &&
                                    Boolean(
                                      owner?.lastName &&
                                        owner?.lastName.trim() !== ""
                                    )
                                  }
                                />
                                {errors[index] && (
                                  <div className="error-text mt-1">
                                    {errors[index].lastName && (
                                      <p>{errors[index].lastName}</p>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-6">
                              <label htmlFor="" className="py-2">
                                {buttonName.email} <sup>*</sup>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <div className="input-wrap">
                                <input
                                  name="email"
                                  type="email"
                                  value={owner?.email}
                                  onChange={(e) => {
                                    handleInputChange(
                                      index,
                                      "email",
                                      e.target.value
                                    );
                                  }}
                                  disabled={
                                    !owner.isNew &&
                                    Boolean(
                                      owner?.email && owner?.email.trim() !== ""
                                    )
                                  }
                                />
                                {errors[index] && (
                                  <div className="error-text mt-1">
                                    {errors[index].email && (
                                      <p>{errors[index].email}</p>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}

                  <div className="row">
                    <div className="col-6">
                      {otherOwners.length < 3 && (
                        <div className="add-owner-btn mt-3 mb-4">
                          <button
                            type="button"
                            className="btn btn-primary owner-btn rounded-0"
                            onClick={handleAddOwner}
                          >
                            {buttonText}
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="col-12 mt-2">
                      <p>{accSetting?.otherOwnercontent}</p>
                    </div>
                  </div>

                  <div className="step-btn-group d-flex justify-content-center align-items-center mt-5 mb-5 flex-wrap">
                    <div className="prev-btn p-1">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={prev}
                      >
                        {pagination.previous}
                      </button>
                    </div>
                    <div className="next-btn p-1">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                      >
                        {pagination.next}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OtherOwners;
